jQuery(document).ready(function ($) {
    var wH; var bH;
    function variables(){
        wH = $(window).height();
        bH = $('body').height();
        hH = $('html').height();
        $body = $('body');
    }

    menu = {
        init: function () {
            menu.trigger();
        },
        trigger: function () {
            $('#trigger_menu').click(function () {
                $(this).toggleClass('is-active');
                $('nav').slideToggle();
            })
        }
    };
    home = {
        init: function () {
            home.slider();
            home.coursesSlider();
            home.testimonialSlider();
        },
        slider: function () {
            $('#slider-home').slick({
                arrows: false,
                autoplay: true,
                autoplaySpeed: 3000,
                fade: true,
            });
        },
        coursesSlider: function () {
            $('#courses-home-slider').slick({
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: false,
                nextArrow: '<svg class="nextArrow" width="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41.66 80.49"><path style="fill: #e62423;" d="M1509.55,1425.15a1,1,0,0,1-.71-1.71l38.54-38.54-38.54-38.54a1,1,0,1,1,1.41-1.41l40,40-40,40A1,1,0,0,1,1509.55,1425.15Z" transform="translate(-1508.55 -1344.67)"/></svg>',
                prevArrow: '<svg class="prevArrow" width="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41.66 80.49"><path style="fill: #e62423;" class="cls-1" d="M1549.21,1344.67a1,1,0,0,1,.71,1.71l-38.54,38.54,38.54,38.54a1,1,0,1,1-1.41,1.41l-40-40,40-40A1,1,0,0,1,1549.21,1344.67Z" transform="translate(-1508.55 -1344.67)"/></svg>',
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    },
                ]
            });
        },
        testimonialSlider: function () {
            $('#testimonials-slider').slick({
                arrows: false,
                autoplay: true,
                autoplaySpeed: 6000,
            });
        }
    };

    variables();

    if($body.hasClass('home')){ home.init(); }

    $(window).resize(function(){
        variables();
    });
});
$(window).load(function(){
    menu.init();
    $('.content').css('opacity',1);
})